import React from "react";

interface EmailInputProps {
  value: string;
  onChange: (value: string) => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  disabled?: boolean;
  inputRef?: React.Ref<HTMLInputElement>;
  placeholder?: string;
}

export const EmailInput: React.FC<EmailInputProps> = ({
  value,
  onChange,
  onKeyDown,
  disabled = false,
  inputRef,
  placeholder = "Add emails, comma separated",
}) => {
  return (
    <div>
      <div className="flex gap-2 items-center w-full">
        <input
          placeholder={placeholder}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={onKeyDown}
          className="input-custom-sm flex-1"
          disabled={disabled}
          ref={inputRef}
        />
      </div>
    </div>
  );
};
